export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAABHAQMAAAAa83T/AAAAA1BMVEX///+nxBvIAAAAC0lEQVQIHWMYVAAAAI4AAYU8iRgAAAAASUVORK5CYII="